import { ADMIN_PERMISSION_ID } from '@/config/environment';
import { usePermissions } from '@/hooks/usePermissions';
import { useViewStore } from '@/stores/useViewStore';

/**
 * Hook para verificar se o usuário atual é admin
 * @returns boolean - true se o usuário tem permissão de admin
 */
export const useIsAdmin = () => {
  const { canAccess, userPermissions } = usePermissions();
  const { view } = useViewStore();

  // Verificação alternativa: se o usuário tem permissão de admin diretamente
  const hasAdminPermission = userPermissions?.includes(ADMIN_PERMISSION_ID);

  // Se estamos na view de admin ou o usuário tem permissão de admin
  return view === 'admin' || hasAdminPermission || canAccess('admin');
};

/**
 * Função utilitária para verificar se o usuário é admin
 * @param userPermissions - Array de IDs de permissões do usuário
 * @returns boolean - true se o usuário tem permissão de admin
 */
export const isAdmin = (userPermissions?: string[]): boolean => {
  if (!userPermissions) return false;

  return userPermissions.includes(ADMIN_PERMISSION_ID);
};
